import styled from 'styled-components';
import slide5 from 'assets/images/desktop/slide5.jpg';
export { Subtitle } from 'styles/shared';

export const Container = styled.section`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 40px 24px;
  background-color: #ff0022;
`;

export const Image = styled.img.attrs({ src: slide5 })`
  height: 100%;
`;
